// components/LottiePlayer.jsx
import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const LottiePlayer = ({ src, width = "300px", height = "300px", loop = true, autoplay = true }) => {
    return (
        <div style={{ width, height }}>
            <DotLottieReact
                src={src}
                loop={loop}
                autoplay={autoplay}
                style={{ width: "100%", height: "100%" }}
            />
        </div>
    );
};

export default LottiePlayer;
